<script setup lang="ts"></script>

<template>
  <p class="">
    <slot />
  </p>
</template>
